<template>
    <div>
        <div class="user-profile-container">
            <span class="lang mr-3">
                <span>
                    <span
                        :class="isUnderline('th')"
                        @click="changeLangTo('th')"
                        class="lang-th pointer mr-1">
                        ไทย
                    </span>
                    |
                    <span
                        :class="isUnderline('en')"
                        @click="changeLangTo('en')"
                        class="lang-en pointer">
                        EN
                    </span>
                </span>
            </span>
            <img
                @click="goToUserProfilePage()"
                class="user-profile-img"
                :src="picture">

            <span
                @click="goToUserProfilePage()"
                class="user-full-name">
                {{ name }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserProfile',

    computed: {
        name () {
            if (this.$store.state && this.$store.state.userName) {
                return this.$store.state.userName
            }
            return ''
        },

        picture () {
            if (this.$store.state && this.$store.state.userImage) {
                return this.$store.state.userImage
            }
            return ''
        }
    },

    methods: {
        isUnderline (lang) {
            if (this.$vuetify.lang.current === lang) {
                return 'text-underline'
            }
            return ''
        },

        goToUserProfilePage () {
            this.$router.push({ name: 'UserProfile' }, () => {})
        },

        changeLangTo (lang) {
            this.$vuetify.lang.current = lang
            localStorage.setItem('lang', lang)
        },

        async getLangFromLocalStorage () {
            const currentLang = localStorage.getItem('lang')
            // has lang in local storage
            if (currentLang) {
                this.$vuetify.lang.current = currentLang
            }
        }
    },

    async mounted () {
        await this.getLangFromLocalStorage()
        await this.$store.dispatch('getUserProfile')
    }
}
</script>

<style lang="scss" scoped>
.user-profile-img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    object-fit: contain;
    background: #c7c7c7;
}
.user-profile-container {
    display: flex;
    justify-content: flex-end;
}
.user-full-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-left: 26px;
    font-family: LexendDeca;
    font-size: 18px;
    color: #131410;
    cursor: pointer;
}
.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    color: #131410;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}
.pointer {
    cursor: pointer;
}
.text-underline {
    text-decoration: underline;
}
</style>
